<template>
  <div class="nav">
    <v-toolbar color="#29339b">

      <!--<v-menu
      class="d-sm-none"
      bottom
      origin="center center"
      transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            dark
            v-on="on"
          >
            Scale Transition
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->

      <v-toolbar-items>
        <v-btn color="white" text :to="{ name: 'Home' }">Home</v-btn>
        <v-btn color="white" text :to="{ name: 'Meet'}">Meet Our Staff</v-btn>
        <v-btn color="white" text :to="{ name: 'About'}">About</v-btn>
        <v-btn color="white" text :to="{ name: 'Contact'}">Contact Us</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-title class="title">Mind Body Health Center</v-toolbar-title>
    </v-toolbar>
  </div>
 </template>


<script>

export default {
  name: 'Nav'
  }



</script>

<style>
.nav {
  font-family: 'Noto Serif', Helvetica, Arial, sans-serif;
}

.title {
  color: white;
  font-family: 'Noto Serif', Helvetica, Arial, sans-serif;
}


</style>
